export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11102.900ef0ab.jpg";